const $ = window.jQuery;
export default $;
export { $ as jQuery };
